import React, { useState, useEffect } from 'react'
import './Header.scss'
import SliceZone from '../HeaderSliceZone/SliceZone/SliceZone'
import VinstriLinkar from './VinstriLinkar/VinstriLinkar'
import { useMediaQuery } from 'react-responsive'
import FullscreenMenu from '../FullscreenMenu/FullscreenMenu'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

function Header(props) {
  const {
    homePage,
    prismicCtx,
    scroll,
    history,
    form
  } = props

  const [header, setHeader] = useState(null)
  const [headerNotFound, setHeaderNotFound] = useState(false)
  const [open, setOpen] = useState(false)
  const [timer, setTimer] = useState(null)
  const [links, setLinks] = useState([])
  const [menuOpen, setMenuOpen] = useState(false)
  const isMobile = useMediaQuery({ query: '(max-width: 1300px)' })

  useEffect(() => {
    if (prismicCtx) {
      prismicCtx.api.getSingle('header').then(doc => {
        if (doc) {
          setHeader(doc)
        } else {
          setHeaderNotFound(true)
          console.log('Something went wrong')
        }
      })
    }
  }, [prismicCtx])

  useEffect(() => {
    if (menuOpen && !isMobile) {
      setMenuOpen(false)
    }
  }, [isMobile])

  let classNames = ''
  let searchImg
  if (homePage) {
    classNames = scroll ? 'header__homePage header__homePage-scroll' : 'header__homePage'
    searchImg = scroll ? '/images/search.png' : '/images/search_white.png'
  } else {
    classNames = 'header__homePage header__homePage-scroll'
    searchImg = '/images/search.png'
  }

  function handleMouseLeave() {
    setOpen(false)
  }

  function handleMenuClick() {
    setMenuOpen(!menuOpen)
  }

  function handleSearchClick() {
    history.push('/search')
  }

  const menuState = (menuOpen && isMobile) ? 'is-active' : null

  if (header) {
    return (
      <header style={{ display: 'flex', flexDirection: 'column', position: homePage ? 'fixed' : 'relative', zIndex: 100, width: '100%' }} onMouseLeave={handleMouseLeave}>
        <div className={classNames} >
          <VinstriLinkar
            header={header}
            prismicCtx={prismicCtx}
            form={form}
          />
          <nav style={{
            marginRight: 30,
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '60vw',
          }}>
            {isMobile || form ? (
              <div className={`hamburger hamburger--slider ${menuState}`} onClick={handleMenuClick} style={{ zIndex: 104 }}>
                <span className="hamburger-box" >
                  <span className={`hamburger-inner ${homePage && !scroll ? 'hamburger-inner-white' : null}`} ></span>
                </span>
              </div>
            ) : (
              <React.Fragment>
                <SliceZone
                  slices={header.data.body}
                  scroll={scroll}
                  homePage={homePage}
                  setOpen={setOpen}
                  timer={timer}
                  setTimer={setTimer}
                  setLinks={setLinks}
                  prismicCtx={prismicCtx}
                />
                <img onClick={handleSearchClick} className='header__search' src={searchImg} alt="Leita" />
              </React.Fragment>

            )}

          </nav>



        </div>
        {menuOpen && (
          <FullscreenMenu
            header={header}
            prismicCtx={prismicCtx}
            setMenuOpen={setMenuOpen}
          />
        )}
      </header>
    );
  } else {
    return null
  }
}

export default withRouter(Header);